import Axios from "axios";
import Api from "./../../services/Api.js";

const baseDomain = "https://nodequery.com/api/servers";
const NodeQueryApiKey = "G8y8eVubQhmctmKjD1qhwjft1eiItWYXNOqcIEay4OpUzKgw";

const state = {
	lists: [],
	server: null,
	networkUsage: [],
	diskUsage: [],
	ramSwap: []
};

const getters = {
	getLists: state => state.lists,
	getServerInfo: state => state.server,
	getNetworkUsage: state => {
		let labels = [];
		let rx = [];
		let tx = [];
		if (state.networkUsage.length) {
			state.networkUsage.map((item) => {
				labels.push(item.data);
				rx.push(item.rx);
				tx.push(item.tx);
			});
		}
		return {
			labels: labels,
			rx: rx,
			tx: tx
		};
	},
	getDiskUsage: state => {
		let labels = [];
		let values = [];
		if (state.diskUsage.length) {
			state.diskUsage.map((item) => {
				labels.push(item.data);
				values.push(item.disk_usage);
			});
		}
		return {
			labels: labels,
			values: values
		};
	},
	getRamSwapUsage: state => {
		let labels = [];
		let ram = [];
		let swap = [];
		if (state.ramSwap.length) {
			state.ramSwap.map((item) => {
				labels.push(item.data);
				ram.push(item.ram_usage);
				swap.push(item.swap_usage);
			});
		}
		return {
			labels: labels,
			ram: ram,
			swap: swap
		};
	}
};

const mutations = {
	PUT_API_KEYS_INTO_STORE(state, item) {
		state.lists = item;
	},
	PUT_SINGLE_SERVER_INFO_INTO_STORE(state, data) {
		state.server = data;
	},
	REFRESH_STORE_AFTER_REMOVE(state, data) {
		let filtered = state.lists.filter((item, index) => {
			return (item.key !== data.key && item.id !== data.id);
		});
		state.lists = filtered;
	},
	COMMIT_NETWORK_USAGE_GRAPH_DATA(state, data) {
		state.networkUsage = data;
	},
	COMMIT_DISK_USAGE_GRAPH_DATA(state, data) {
		state.diskUsage = data;
	},
	COMMIT_RAM_SWAP_GRAPH_DATA(state, data) {
		state.ramSwap = data;
	}
};
const actions = {
	async GET_API_KEYS_FROM_CACHE({ commit }) {
		await Api.get('servers/api-keys')
			.then((response) => {
				if (response.data.list) {
					commit('PUT_API_KEYS_INTO_STORE', response.data.list);
				}
			})
	},
	async ADD_NEW_API_KEY_INTO_CACHE({commit}, data) {
		await Api.post('servers/api-keys', data);
	},
	async GET_SINGLE_SERVER_DETAILS({commit}, data) {
		await Api.get(`servers/api-keys/${data.key}/${data.server}`)
			.then(response => commit('PUT_SINGLE_SERVER_INFO_INTO_STORE', response.data.data))
			.catch(err => this.$weNotify("success", "Something went wrong while getting data using api key: " + data.key));
	},
	async REMOVE_SERVER_FROM_CACHE({commit}, data) {
		await Api.post(`servers/api-keys/${data.key}/${data.id}`).then(response => {
				commit('REFRESH_STORE_AFTER_REMOVE', { key: data.key, id: data.id });
			});
	},
	// Graphs
	NETWORK_USAGE_GRAPH_DATA_FROM_API({commit}, data) {
		return new Promise((resolve, reject) => {
			Api.get(`servers/network-usage/${data.serverId}?type=${data.type}`).then((response) => {
				commit('COMMIT_NETWORK_USAGE_GRAPH_DATA', response.data);
				return resolve({ data: 'Network usage graph data initiated to store' });
			});
		});
	},
	DISK_USAGE_GRAPH_DATA_FROM_API({commit}, data) {
		return new Promise((resolve, reject) => {
			Api.get(`servers/disk-usage/${data.serverId}?type=${data.type}`).then((response) => {
				commit('COMMIT_DISK_USAGE_GRAPH_DATA', response.data);
				return resolve({ data: 'Disk usage graph data initiated to store' });
			});
		});
	},
	RAM_SWAP_GRAPH_DATA_FROM_API({commit}, data) {
		return new Promise((resolve, reject) => {
			Api.get(`servers/ram-swap/${data.serverId}?type=${data.type}`).then((response) => {
				commit('COMMIT_RAM_SWAP_GRAPH_DATA', response.data);
				return resolve({ data: 'Ram Swap usage graph data initiated to store' });
			});
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
